import { createBrowserHistory } from "history";


// if( *some-requirement*){
//     history.push("/desiredRoute")
//     }. 

export default createBrowserHistory(); 